module.exports = __webpack_public_path__ + "img/3.fa6f76dd.jpg";